// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/PPObjectSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/PPObjectSans-Slanted.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/PPObjectSans-Heavy.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/PPObjectSans-HeavySlanted.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/Figtree[wght].woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/Figtree-Italic[wght].woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Object Sans
 * This beautiful font was designed by Alex Slobzheninov.
 * ---------------------------------------------------------------------------
 * Object Sans is a contemporary type family that puts together the best
 * qualities of Swiss neo-grotesks and geometric fonts. It’s a multifunctional
 * workhorse designed to work best in any printed and on-screen contexts.
 * It is free to use for personal purposes. If you would like to use it
 * for commercial purposes, you will need to purchase a license.
 * for more information visit https://pangrampangram.com/products/object-sans
 * or check ./assets/EULA-PangramPangram-FreeForPersonalUse-MAY2021.pdf
 * Alex Slobzheninov https://www.behance.net/slobzheninov
 * ---------------------------------------------------------------------------
 */

@font-face {
  font-family: "Object Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}

@font-face {
  font-family: "Object Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
  font-style: italic;
}

@font-face {
  font-family: "Object Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
  font-weight: bold;
}

@font-face {
  font-family: "Object Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("opentype");
  font-weight: bold;
  font-style: italic;
}

/* Figtree
 * ---------------------------------------------------------------------------
 */

@font-face {
  font-family: "Figtree";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2");
  font-weight: 300 900;
}

@font-face {
  font-family: "Figtree";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2");
  font-weight: 300 900;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./functions/gaswerk/styles.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;;AAEF;EACE,0BAA0B;EAC1B,+DAAgE;AAClE;;AAEA;EACE,0BAA0B;EAC1B,+DAAgE;EAChE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,+DAA8D;EAC9D,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,+DAAqE;EACrE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE;;AAEF;EACE,sBAAsB;EACtB,4DAAwD;EACxD,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,4DAA+D;EAC/D,oBAAoB;EACpB,kBAAkB;AACpB","sourcesContent":["/* Object Sans\n * This beautiful font was designed by Alex Slobzheninov.\n * ---------------------------------------------------------------------------\n * Object Sans is a contemporary type family that puts together the best\n * qualities of Swiss neo-grotesks and geometric fonts. It’s a multifunctional\n * workhorse designed to work best in any printed and on-screen contexts.\n * It is free to use for personal purposes. If you would like to use it\n * for commercial purposes, you will need to purchase a license.\n * for more information visit https://pangrampangram.com/products/object-sans\n * or check ./assets/EULA-PangramPangram-FreeForPersonalUse-MAY2021.pdf\n * Alex Slobzheninov https://www.behance.net/slobzheninov\n * ---------------------------------------------------------------------------\n */\n\n@font-face {\n  font-family: \"Object Sans\";\n  src: url(\"./assets/PPObjectSans-Regular.otf\") format(\"opentype\");\n}\n\n@font-face {\n  font-family: \"Object Sans\";\n  src: url(\"./assets/PPObjectSans-Slanted.otf\") format(\"opentype\");\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Object Sans\";\n  src: url(\"./assets/PPObjectSans-Heavy.otf\") format(\"opentype\");\n  font-weight: bold;\n}\n\n@font-face {\n  font-family: \"Object Sans\";\n  src: url(\"./assets/PPObjectSans-HeavySlanted.otf\") format(\"opentype\");\n  font-weight: bold;\n  font-style: italic;\n}\n\n/* Figtree\n * ---------------------------------------------------------------------------\n */\n\n@font-face {\n  font-family: \"Figtree\";\n  src: url(\"./assets/Figtree[wght].woff2\") format(\"woff2\");\n  font-weight: 300 900;\n}\n\n@font-face {\n  font-family: \"Figtree\";\n  src: url(\"./assets/Figtree-Italic[wght].woff2\") format(\"woff2\");\n  font-weight: 300 900;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
